module.exports = __webpack_public_path__ + "static/img/2029.6673334.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2029.jpg
// module id = 319
// module chunks = 0